module.exports = __webpack_public_path__ + "static/media/icon-desk-woman.3f57989d.svg";